import styled from '@emotion/styled';
import { flex, FlexConfig } from '@/common/styles';

export const Flex = styled.div<FlexConfig>`
  ${flex}
`;
